"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getProductCodes = void 0;
var _tsUtils = require("@ori/ts-utils");
const getProductCodes = (products)=>{
    var _products_map_filter;
    return (_products_map_filter = products === null || products === void 0 ? void 0 : products.map((productBox)=>productBox === null || productBox === void 0 ? void 0 : productBox.productCode).filter(_tsUtils.isNonNullable)) !== null && _products_map_filter !== void 0 ? _products_map_filter : [];
};
exports.getProductCodes = getProductCodes;
